import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";

@Component({
    selector: "general-ticket",
    templateUrl: "./general-ticket.component.html",
    styleUrls: ["./general-ticket.component.scss"],
    standalone: false
})
export class GeneralTicketComponent implements OnInit, OnChanges {
  @Input() form: FormGroup;
  @Input() category: string;
  @Input() isVisible: boolean = false;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.category) {
      if (this.isVisible) this.initiateForm();
    }
  }

  initiateForm() {
    this.form.addControl("message", new FormControl("", [Validators.required]));
  }

  get message() {
    return this.form.get("message");
  }

  get title() {
    return this.form.get("title");
  }
}
